<template>
    <div class="col-lg-7  mb-3" :class="{'chart-loading': loading}">
        <h3 class="mb-3"><b>Tổng Điểm Rủi Ro Theo Danh Mục</b></h3>
        <div class="mb-3">
            Tổng điểm: <b v-text="totalDistanceYear"></b>
        </div>
        <Chart type="bar" :data="categoryData" :options="basicOptions" :key="componentKey"/>
    </div>
</template>

<script>
import Chart from '@/components/Chart.vue';
export default {
    name: "chartCategory",
    props:{
        category: Object,
        loading: Boolean
    },
    components: {
        Chart
    },
    computed: {
        totalDistanceYear() {
            if (this.total_arr.length > 0) {
                var total = this.total_arr.reduce((a, b) => a + b, 0);
                return this.$commonFuction.numberFormat(total, 0, '.', ',');
            }
            return 0;
        }
    },
    watch: {
        "$props.category"() {
            this.categoryData.labels = this.category?.dataChart?.label ?? [];
            this.categoryData.datasets[0].data = this.category?.dataChart?.data ?? [];
            this.total_arr = this.category?.dataChart?.data ?? [];
            // this.result.total = this.category?.dataChart?.data ? this.category.dataChart.data.reduce((a, b) =>  a + b, 0) : 0;
            // this.result.total = this.category?.dataChart?.total ?? 0;
            this.componentKey++;
        }
    },
    data() {
        return {
            componentKey: 0,
            total_arr: [],
            categoryData: {
                // labels: ['Môi trường', 'Vật lý', 'Hóa học', 'Tiếng ồn', 'Con người', 'Ngã cao', 'Nhóm khác'],
                datasets: [
                    {
                        // label: 'Kế hoạch',
                        backgroundColor: '#146082',
                        maxBarThickness: 32,
                        // data: [1000, 1240, 300, 1280, 780, 500, 330]
                    }
                ]
            },
            basicOptions: {
                plugins: {
                    legend: false,
                    datalabels: {
                        color: '#000000',
                        anchor: 'end',
                        align: 'end',
                        clamp: true,
                        formatter: function(value) {
                            return String(value).replace(/(.)(?=(\d{3})+$)/g, "$1,");
                        }
                    }
                }
            }
        }
    }
}
</script>